var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('MarketOverallIncomeMonthlyComponent',{attrs:{"isMainLoading":_vm.isMainLoading,"tabType":_vm.tab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }